import SERVICES, { getServiceConfigProperty } from '@/constants/services';
import { createNotificationStringParser } from '@whitelist/wl-old-library/utils/notifications';
const l = {
    PASSPORT_URL: SERVICES.PASSPORT,
    TRADE_URL: SERVICES.TRADE,
    COMPANY_NAME: getServiceConfigProperty('companyName').toString(),
    COMPANY_ABRV: getServiceConfigProperty('companyAbrv').toString()
};
export const parseNotificationString = createNotificationStringParser(l);
